module.exports = __webpack_public_path__ + "img/back.e4ece9b8.png";